import axios from "axios";

// https://solreviews-server.herokuapp.com/"
// http://localhost:3001/"

const BASE_URL = "https://nft-review-server.vercel.app/";
let token;
 let TOKEN='';
if (localStorage.getItem("token")) {
 
   token= localStorage.getItem("token")
   
   if (token) {

    TOKEN = token;
    
   }
}




export const publicRequest = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-type" : "application/json"
  }
});
export const userRequest = axios.create({
  baseURL: BASE_URL,
  headers: { Authorization: `Bearer ${TOKEN}` },
});
